import "./ResultBanner.css";

export default function ResultBanner(props) {
  if (props.variant === "finalist") {
    return (
      <div className="banner banner-finalist row" role="status">
        <span className="banner-icon" aria-hidden="true">🎉</span>
        <p className="banner-copy t-body">
          Congratulations, you're through to the final round. Your dashboard
          will tell you what to upload next.
        </p>
      </div>
    );
  }

  if (props.variant === "result") {
    return (
      <div className="banner banner-result row">
        <div className="banner-place col">
          <span className="banner-place-value">{props.placement}</span>
        </div>
        <div className="banner-result-copy col">
          <span className="t-eyebrow t-brand">Results published</span>
          <h2 className="t-h1">
            {{ "1st": "First place", "2nd": "Second place", "3rd": "Third place" }[
              props.placement
            ] || "Placed"}
          </h2>
          <p className="t-body t-dim">
            Judging is complete and prizes are being handed out.
          </p>
        </div>
      </div>
    );
  }

  return null;
}
